import AccountCircle from "@mui/icons-material/AccountCircle";
import ChevronRight from "@mui/icons-material/ChevronRight";
import CloudDownloadOutlined from "@mui/icons-material/CloudDownloadOutlined";
import ContactSupportOutlined from "@mui/icons-material/ContactSupportOutlined";
import Edit from "@mui/icons-material/Edit";
import Launch from "@mui/icons-material/Launch";
import LockOutlined from "@mui/icons-material/LockOutlined";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import React from "react";
import styled from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { HXMobileButton } from "./HXButton";
import { LighterText, LightText, mobilePageHPadding } from "./HXMobilePage.styles";
import { svgGradientStyle } from "./SVGGradients";
import HelpFilled from "@mui/icons-material/Help";
import LogoutFilled from "@mui/icons-material/Logout";
import PersonFilled from "@mui/icons-material/Person";
export const Parent = styled(FlexColumnDiv) `
    gap: 32px;
    padding: 0 ${mobilePageHPadding}px;
`;
export const ProfileContainer = styled(FlexColumnDiv) `
    padding: 16px;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background: ${colors.white_main};
`;
export const ProfileContainerContent = styled(FlexRowDiv) `
    align-items: center;
    gap: 13px;
    align-self: stretch;
`;
export const AccountCircleIcon = styled(AccountCircle) `
    ${svgGradientStyle("accents_gradient")}
    width: 42px;
    height: 42px;
`;
export const SettingsOutlinedIcon = styled(SettingsOutlined) `
    color: ${colors.accents_sunset};
    width: 24px;
    height: 24px;
`;
export const CloudDownloadOutlinedIcon = styled(CloudDownloadOutlined) `
    color: ${colors.accents_sunset};
    width: 24px;
    height: 24px;
`;
export const ContactSupportOutlinedIcon = styled(ContactSupportOutlined) `
    color: ${colors.accents_sunset};
    width: 24px;
    height: 24px;
`;
export const LockOutlinedIcon = styled(LockOutlined) `
    color: ${colors.accents_sunset};
    width: 24px;
    height: 24px;
`;
export const ChevronRightButton = styled(IconButton).attrs({
    size: "medium",
    children: React.createElement(ChevronRight),
}) `
    padding: 0;
`;
export const LaunchButton = styled(IconButton).attrs({
    size: "medium",
    children: React.createElement(Launch),
}) `
    padding: 0;
`;
export const ManageProfileButton = styled(HXMobileButton).attrs({ startIcon: React.createElement(Edit) }) `
    align-self: stretch;
`;
export const RowContainer = styled(FlexRowDiv) `
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    cursor: pointer;
`;
export const RowStartIconAndNameContainer = styled(FlexRowDiv) `
    display: flex;
    align-items: center;
    gap: 8px;
`;
export const TextButton = styled(HXMobileButton).attrs({ text: true }) `
    padding: 6px 8px;
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const TextButtonWithLaunchEndIcon = styled(TextButton).attrs({ text: true, endIcon: React.createElement(Launch) }) ``;
export const DTCParent = styled(FlexColumnDiv) `
    gap: 40px;
    padding: 0 ${mobilePageHPadding}px;
    align-items: center;
`;
export const DTCSummaryContainer = styled(FlexColumnDiv) `
    width: 100%;
    padding-bottom: 24px;
`;
export const DTCCallToActionContainer = styled(FlexColumnDiv) `
    gap: 12px;
    align-self: stretch;
`;
export const DTCInfoLighterText = styled(LighterText) `
    font-size: ${fontSizes.TINY};
    padding-top: 2px;
    text-align: center;
`;
export const DTCSettingsContainer = styled(FlexColumnDiv) `
    gap: 0px;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    border: 1px solid ${colors.blue_10};
    align-self: stretch;
`;
export const DTCSettingsDividerContainer = styled.div `
    align-self: stretch;
    align-content: center;
    height: 8px;
`;
export const DTCSettingsDivider = styled(Divider).attrs({ variant: "fullWidth" }) `
    border-color: ${colors.blue_10};
`;
export const DTCRowContainer = styled(FlexRowDiv) `
    margin: 12px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;
export const DTCRowStartIconAndNameContainer = styled(FlexRowDiv) `
    display: flex;
    align-items: center;
    gap: 8px;
`;
export const DTCSettingsPersonIcon = styled(IconButton).attrs({
    children: React.createElement(PersonFilled),
}) `
    width: 36px;
    height: 36px;
    border-radius: 999px;
    padding: 8px;
    background-color: ${colors.blue_10};
`;
export const DTCSettingsHelpIcon = styled(IconButton).attrs({
    children: React.createElement(HelpFilled),
}) `
    width: 36px;
    height: 36px;
    border-radius: 999px;
    padding: 8px;
    background-color: ${colors.blue_10};
`;
export const DTCSettingsLogoutIcon = styled(IconButton).attrs({
    children: React.createElement(LogoutFilled),
}) `
    width: 36px;
    height: 36px;
    border-radius: 999px;
    padding: 8px;
    background-color: ${colors.blue_10};
`;
export const DTCSettingsChevronRightIcon = styled(IconButton).attrs({
    children: React.createElement(ChevronRight),
}) `
    width: 24px;
    height: 24px;
    padding: 8px;
`;
export const DTCSettingsLaunchIcon = styled(IconButton).attrs({
    children: React.createElement(Launch),
}) `
    width: 24px;
    height: 24px;
    padding: 8px;
`;
export const DTCSettingsText = styled(LightText) `
    font-weight: ${fontWeights.SEMI_BOLD};
    flex: 1;
`;
